import { DragIndicatorOutlined } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { FC } from "react";
import { makeSxStyles } from "ui";
import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";
import { MapMarker } from "../../../components/map/map.types";

interface AddressProps extends MapMarker {
  index?: number | undefined;
}

const AddressBoxDraggable: FC<AddressProps> = ({
  id,
  customer,
  duration,
  address,
}) => {
  const styles = useStyles();

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id,
    });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={{
        ...style,
        width: "100%",
        padding: "16px",
        borderRadius: "8px",
        backgroundColor: "#282A2D",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
      {...listeners}
      {...attributes}
    >
      <Box sx={styles.dragContent}>
        <Box
          sx={{
            marginBottom: "0",
          }}
        >
          <Box sx={styles.addressRowItem}>
            <Typography sx={styles.addressStyle} data-testid="address">
              {address}
            </Typography>
          </Box>
        </Box>
        <Box sx={styles.addressRowItem} marginBottom={0}>
          <Typography data-testid="customer-name">
            {customer?.firstName} {customer?.lastName}
          </Typography>
        </Box>
        <Box sx={styles.addressRowItem}>
          <Typography>EST:</Typography>
          <label>{duration}</label>
        </Box>
      </Box>
      <Box sx={styles.dragIndicator}>
        <DragIndicatorOutlined />
      </Box>
    </div>
  );
};

const useStyles = makeSxStyles(({ palette }) => ({
  addressBoxCard: {
    width: "100%",
    padding: "16px",
    borderRadius: "8px",
    backgroundColor: palette.grey[600],
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  addressStyle: {
    color: palette.primary.main,
    fontWeight: "600",
  },
  addressRowItem: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "4px",
    fontSize: "14px",
    width: "100%",
  },
  typeRateButton: {
    padding: "4px 8px",
    borderRadius: "8px",
    backgroundColor: "#C5C6C926",
    lineHeight: "16px",
    fontSize: "12px",
  },
  dragContent: {
    flexGrow: "1",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginRight: "6px",
  },
  dragIndicator: {
    minWidth: "28px",
    height: "28px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "move",
  },
}));

export default AddressBoxDraggable;
